<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você poderá gerenciar e editar as informações da tarefa. A
              data de inicío e o deadline controlam o período em que a tarefa
              aceitará respostas. Na listam abaixo também são exibidas todas as
              respostas submetidas pelas startups do batch a esta tarefa.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div class="card shadow mb-3">
            <div class="card-header bg-transparent">
              <h3 class="mb-0">
                <i class="fas fa-clipboard-list mr-1"></i>
                Tarefa do batch
                <span v-if="batch">
                  <span class="text-warning">{{ batch.name }}</span>
                  <router-link
                    :to="`/admin/batches/${batch.id}/acompanhamento`"
                  >
                    <i class="ml-2 fas fa-eye text-sm"></i>
                  </router-link>
                </span>
                <base-button
                  size="sm"
                  type="danger"
                  class="float-right"
                  @click="handleOpenModalremoveConfirmation"
                >
                  <i class="fas fa-trash mr-1"></i> Deletar tarefa
                </base-button>
              </h3>
            </div>
            <div class="card-body vld-parent" ref="task_container">
              <div class="row">
                <div class="col-lg-6">
                  <base-input label="Título da tarefa">
                    <textarea
                      rows="1"
                      class="form-control form-control"
                      placeholder="Digite aqui..."
                      v-model="model.task.title"
                    >
                    </textarea>
                  </base-input>
                </div>
                <div class="col-6">
                  <label class="form-control-label">
                    Status da tarefa
                    <i
                      v-if="model.task.status"
                      class="fas fa-info-circle ml-1"
                      :title="getStatusDescription"
                    ></i>
                  </label>
                  <base-input addon-left-icon="fas fa-cogs">
                    <select class="form-control" v-model="model.task.status">
                      <option selected disabled value="">
                        Selecione o status da tarefa
                      </option>
                      <option
                        v-for="status in taskStatus"
                        :key="status.key"
                        :value="status.key"
                      >
                        {{ status.value }}
                      </option>
                    </select>
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label class="form-control-label">
                    Família (opcional)
                    <i
                      class="fas fa-info-circle ml-1"
                      title="A tag famíla permite que as tarefas sejam agrupadas para facilitar a posterior visualização de tarefas de uma mesma categoria."
                    ></i>
                  </label>
                  <base-input
                    placeholder="Família da tarefa"
                    input-classes="form-control"
                    addon-left-icon="fas fa-layer-group"
                    v-model="model.task.family"
                  />
                </div>
                <div class="col-lg-6 text-center text-lg-left">
                  <base-input label="Resposta numérica?">
                    <br />
                    <base-switch
                      v-bind:value="model.task.is_number"
                      @input="isNumberChangeHandler($event)"
                    />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group has-label">
                    <label class="form-control-label">Data de início</label>
                    <base-input
                      type="date"
                      placeholder="Data de início"
                      input-classes="form-control"
                      addon-left-icon="ni ni-calendar-grid-58"
                      v-model="model.task.start_date"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group has-label">
                    <label class="form-control-label"
                      >Deadline (opcional)</label
                    >
                    <base-input
                      type="date"
                      placeholder="Deadline"
                      input-classes="form-control"
                      addon-left-icon="ni ni-calendar-grid-58"
                      v-model="model.task.deadline"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 te-container-edditable">
                  <base-input label="Descrição da tarefa (opicional)">
                    <quill-editor
                      v-model="model.task.description"
                      :options="editorEdittableDescription"
                    >
                    </quill-editor>
                  </base-input>
                </div>
                <div class="col-lg-6 te-container-edditable">
                  <base-input label="Instruções para a submissão">
                    <quill-editor
                      v-model="model.task.instructions"
                      :options="editorEdittableInstructions"
                    >
                    </quill-editor>
                  </base-input>
                </div>
              </div>
              <p class="text-muted text-sm text-right" v-if="task">
                Criada em {{ formatDate(task.created_at, "L") }}. Última
                atualização em {{ formatDate(task.updated_at, "L") }}.
              </p>
              <div class="col-12 text-center" v-if="error">
                <base-alert type="danger">{{ error }}</base-alert>
              </div>
              <div class="col-12 text-center" v-if="success">
                <base-alert type="success">{{ success }}</base-alert>
              </div>
              <base-button
                type="primary"
                @click="handleUpdateTask()"
                class="mt-1 float-right"
                :disabled="!isValidModel"
              >
                Salvar alterações
              </base-button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="card shadow mb-3">
            <div class="card-header bg-transparent">
              <h3 class="mb-0">
                Respostas
                <span
                  class="bg-white text-dark rounded border px-2 py-1 float-right font-weight-normal text-sm"
                  v-if="totalResponses && batch.startups.length"
                >
                  Taxa de respostas:
                  <span class="text-warning font-weight-bold"
                    >{{
                      Math.round(
                        (totalResponses / batch.startups.length) * 100,
                        2
                      )
                    }}%</span
                  >
                </span>
              </h3>
            </div>
            <div class="card-body vld-parent pt-2" ref="list_startups_batch">
              <div
                v-if="task && (!task.responses || !task.responses.length)"
                class="text-center text-warning mt-3"
              >
                Não há respostas para esta tarefa até o momento
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="text-muted text-right" v-if="totalResponses">
                    <b class="font-weight-bold"
                      >{{ totalResponses }} respostas</b
                    >
                    de um total de
                    <b class="font-weight-bold"
                      >{{ batch.startups.length }} startups</b
                    >
                    no batch
                  </p>
                </div>
                <div
                  class="col-12"
                  v-for="response in task.responses"
                  :key="'response_' + response.id"
                >
                  <div class="card mb-3">
                    <div class="card-body pt-3 pb-2">
                      <div class="row pt">
                        <div class="col-lg-4 text-center">
                          <div class="card-profile-image pt-3">
                            <img
                              :src="getStartupLogoPath(response.startup.logo)"
                              class="my-3"
                              alt="..."
                            />
                          </div>
                          <h2 class="card-title text-orange mb-0 mt-7">
                            {{ response.startup.name }}
                          </h2>
                          <div class="h5 font-weight-300">
                            <i class="ni ni-pin-3 mr-2"></i
                            >{{ response.startup.city || "..." }},
                            {{ response.startup.state || "..." }}
                          </div>
                          <div class="mb-2">
                            <base-button
                              @click="
                                handleViewStartupTasks(response.startup.user_id)
                              "
                              type="white"
                              icon="fas fa-clipboard"
                              :iconOnly="true"
                              class="text-primary"
                              title="Ver todas as respostas"
                            ></base-button>
                            <base-button
                              @click="
                                handleViewStartupMetrics(
                                  response.startup.user_id
                                )
                              "
                              type="white"
                              icon="fas fa-tachometer-alt"
                              class="text-warning"
                              :iconOnly="true"
                              title="Ver as métricas de desempenho"
                            ></base-button>
                          </div>
                        </div>
                        <div class="col-lg-8 my-3 te-container-read-only">
                          <div v-if="task.is_number">
                            <h4 class="heading-small mb-2 pl-1">
                              Resposta da startup:
                              <span
                                class="text-md font-weight-bold bg-white rounded border ml-1 px-3 py-1"
                                >{{ response.answer_number }}</span
                              >
                            </h4>
                            <h4 class="heading-small text-muted mb-2 pl-1">
                              Comentários
                            </h4>
                          </div>
                          <h4 class="heading-small text-muted mb-2 pl-1" v-else>
                            Resposta da startup
                          </h4>
                          <div class="col-12">
                            <quill-editor
                              v-model="response.answer_text"
                              :options="editorReadOnly"
                              disabled="disabled"
                            >
                            </quill-editor>
                            <div class="mt-2">
                              <div class="text-muted text-sm text-right">
                                Respondido em:
                                {{ formatDate(response.created_at, "L") }}.
                                Última atualização em:
                                {{ formatDate(response.updated_at, "L") }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.removeConfirmation"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-exclamation-circle fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja
            <span class="text-danger">excluir esta tarefa</span>?
          </h4>
          <p class="mt-3 mb-0">
            Se houverem, todas as respostas submetidas a tarefa pelas startups
            serão perdidas.
          </p>
        </div>
        <div class="col-12 text-center" v-if="modals.removeError">
          <base-alert type="danger"
            >Ocorreu um erro ao remover a tarefa. Tente novamente.</base-alert
          >
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="l-auto"
          @click="modals.removeConfirmation = false"
        >
          Voltar
        </base-button>
        <base-button type="white" class="text-danger" @click="handleDeleteTask">
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api";

export default {
  name: "tasks_list",
  components: {
    quillEditor,
  },
  data() {
    return {
      model: {
        task: {
          title: "",
          status: "",
          family: "",
          start_date: "",
          deadline: "",
          description: "",
          instructions: "",
          is_number: false,
        },
      },
      taskStatus: [
        {
          key: "visible",
          value: "Visível",
          description:
            "Uma tarefa visível pode ser vista pelas startups do batch, que podem realizar a submissão de suas respostas caso a data atual respeite a data de início e o deadline da tarefa.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Uma tarefa invisível fica oculta para todas as startups, não aparecendo nem mesmo em seu histórico.",
        },
      ],
      editorEdittableDescription: {
        placeholder:
          "Descreva a tarefa (lembre-se, se necessário, você pode linkar arquivos pelo editor)",
      },
      editorEdittableInstructions: {
        placeholder:
          "Digite aqui os detalhes sobre o que a startup deve enviar  (lembre-se, se necessário, você pode linkar arquivos pelo editor)",
      },
      editorReadOnly: {
        placeholder: "N/A",
        readOnly: true,
        theme: "bubble",
      },
      totalResponses: "",
      task: "",
      batch: "",
      error: "",
      success: "",
      modals: {
        removeConfirmation: false,
        removeError: false,
      },
    };
  },
  async mounted() {
    const loaderBatch = this.$loading.show({
      container: this.$refs.list_startups_batch,
      width: 90,
      height: 90,
    });
    const loaderTask = this.$loading.show({
      container: this.$refs.task_container,
      width: 90,
      height: 90,
    });
    await this.loadBatch();
    try {
      await this.loadTask();
      loaderTask.hide();
      loaderBatch.hide();
    } catch (e) {
      this.$toasted.error(
        "Ocorreu um erro ao recuperar as informações da tarefa"
      );
    }
  },
  methods: {
    async loadBatch() {
      try {
        const { data: batch } = await api.get(
          `/batches/${this.$route.params.idBatch}`
        );
        if (!batch) {
          this.$toasted.error("Batch não encontrado");
          this.$router.push("/admin/batches");
          return;
        }
        this.batch = batch;
      } catch (e) {
        this.$toasted.error("Error ao carregar informações do batch");
        this.$router.push(`/admin/batches/${this.batch.id}/acompanhamento`);
      }
    },
    async loadTask() {
      const { data: task } = await api.get(
        `/batches/${this.batch.id}/tasks/${this.$route.params.idTask}`
      );
      if (!task) {
        this.$toasted.error("Tarefa não encontrada");
        this.$router.push(`/admin/batches/${this.batch.id}/acompanhamento`);
        return;
      }
      task.is_number = task.is_number ? true : false;
      this.task = task;
      this.totalResponses = task.responses.length;
      for (const key in this.model.task) {
        this.model.task[key] = task[key];
      }
    },
    async handleUpdateTask() {
      this.error = this.success = "";
      const loader = this.$loading.show({
        container: this.$refs.task_container,
        width: 90,
        height: 90,
      });
      try {
        const task = this.model.task;
        await api.put(
          `/batches/${this.$route.params.idBatch}/tasks/${this.task.id}`,
          task
        );
        this.$toasted.show("Tarefa atualizada com sucesso");
        this.success =
          "As informações da tarefa foram atualizadas com sucesso.";
      } catch (e) {
        this.error = "Ocorreu um erro ao atualizar a tarefa. Tente novamente.";
        this.$toasted.error(this.error);
      }
      loader.hide();
    },
    getStartupLogoPath(logo) {
      const defaultLogoPath = "/img/pages/default_logo.png";
      if (!logo) return defaultLogoPath;
      return logo.url;
    },
    handleViewStartupTasks(startupId) {
      this.$router.push(
        `/admin/batches/${this.batch.id}/acompanhamento/startups/${startupId}/respostas`
      );
    },
    handleViewStartupMetrics(startupId) {
      this.$router.push(
        `/admin/batches/${this.batch.id}/acompanhamento/startups/${startupId}/metricas`
      );
    },
    handleOpenModalremoveConfirmation() {
      this.modals.removeConfirmation = true;
    },
    async handleDeleteTask() {
      this.modals.removeError = false;
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(
          `/batches/${this.$route.params.idBatch}/tasks/${this.task.id}`
        );
        this.$toasted.show("Tarefa removida com sucesso");
        this.$router.push(`/admin/batches/${this.batch.id}/acompanhamento`);
      } catch (e) {
        this.error = "Ocorreu um erro ao remover a tarefa.";
        this.$toasted.error(this.error);
        this.modals.removeError = true;
      } finally {
        loader.hide();
      }
    },
    isNumberChangeHandler(event) {
      if (typeof event === "boolean") this.model.task.is_number = event;
    },
  },
  computed: {
    getStatusDescription() {
      const selectedStatus = this.taskStatus.find(
        (status) => status.key === this.model.task.status
      );
      return selectedStatus ? selectedStatus.description : "";
    },
    isValidModel() {
      const requiredFields = ["title", "status", "start_date", "instructions"];
      for (const key of requiredFields) {
        if (this.model.task[key] === "") return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.task-card {
  margin: 0;
  padding: 1.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25;
  color: #32325d;
  background-color: #f6f9fc;
  border-radius: 0.375rem;
  border: 0;
  text-align: left;
  font-family: inherit;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  -moz-appearance: none;
  cursor: pointer;
  width: 100%;
  margin: 0.5rem 0;

  &:hover {
    background-color: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;
  }

  > div {
    align-items: center;
    display: flex;
  }

  i {
    box-sizing: content-box;
    color: #5e72e4;
    vertical-align: middle;
    font-size: 1.5rem;
  }

  span {
    display: inline-block;
    font-size: 0.875rem;
    line-height: 1.5;
    margin-left: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
}

.card-profile-image img {
  width: 110px;
  height: 110px;
  border-radius: 10%;
}
</style>
<style>
.te-container-read-only .quill-editor .ql-container,
.te-container-read-only .quill-editor .ql-container .ql-editor {
  min-height: 5rem;
  max-height: 17rem;
  width: 100%;
}

.te-container-edditable .quill-editor .ql-container,
.te-container-edditable .quill-editor .ql-container .ql-editor {
  height: 11rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
